/**
 * electric auth token revoke
 *
 * Revoke an API token.
 */

import { Command } from 'commander'
import { createClient } from '../../../client.js'
import { handleError, EXIT_VALIDATION_ERROR } from '../../../lib/errors.js'
import {
  isQuiet,
  printQuiet,
  printJson,
  printSuccess,
} from '../../../output.js'
import { confirm, isInteractive } from '../../../lib/confirm.js'

export const tokenRevokeCommand = new Command(`revoke`)
  .description(`Revoke an API token`)
  .argument(`<token-id>`, `Token ID to revoke`)
  .option(`--force`, `Skip confirmation prompt`)
  .action(async (tokenId: string, opts) => {
    const json = tokenRevokeCommand.parent?.parent?.parent?.opts().json ?? false
    try {
      if (!opts.force) {
        if (json) {
          process.stderr.write(
            JSON.stringify({
              error: `VALIDATION_ERROR`,
              message: `--force is required with --json`,
              exitCode: EXIT_VALIDATION_ERROR,
            }) + `\n`
          )
          process.exit(EXIT_VALIDATION_ERROR)
        }

        const confirmed = await confirm(`Revoke token ${tokenId}? [y/N] `)
        if (!confirmed) {
          if (!isInteractive()) {
            process.stderr.write(
              `Use --force to skip confirmation in non-interactive mode.\n`
            )
            process.exit(EXIT_VALIDATION_ERROR)
          }
          process.stderr.write(`Aborted.\n`)
          return
        }
      }

      const client = createClient()
      const result = await client.tokens.revoke({ tokenId })

      if (isQuiet()) {
        printQuiet(tokenId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Token ${tokenId} revoked.`)
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
